import Charity from "../../Components/Charity";
const CharityPage = () => {
  return (
      <>
        <Charity />
      </>
  );
};
export default CharityPage;
